"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[814],{

/***/ 70814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75713);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const NewsletterContainer = ({
  title,
  description
}) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .NewsletterComponent */ .OA, {
  title: title,
  description: description
});

/* harmony default export */ __webpack_exports__["default"] = (NewsletterContainer);

/***/ })

}]);